/*
 * AUTO-GENERATED, DO NOT EDIT
 */
import React from 'react';
function DropIcon(props, svgRef) {
    return (React.createElement("svg", Object.assign({ "data-sanity-icon": "drop", width: "1em", height: "1em", viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: svgRef }, props),
        React.createElement("path", { d: "M18.5 14.5C18.5 18 16 20.5 12.5 20.5C9 20.5 6.5 18 6.5 14.5C6.5 11 9.5 7.50001 12.5 4.5C15.5 7.5 18.5 11 18.5 14.5Z", stroke: "currentColor", strokeWidth: 1.2 })));
}
const ForwardRef = React.forwardRef(DropIcon);
export default ForwardRef;
//# sourceMappingURL=dropIcon.js.map